// import axios from 'axios'
let url = 'Rotinas/'
import http from './http'
// require('@/service/service_autoatendimento/httpsemtoken')
// const urlAdaptor = sessionStorage.getItem('APIAdaptor')
// var http = axios.create({
//   baseURL: urlAdaptor
// })


export function getEmpresa() {
    return http.get(url + 'empresa/nomefantasia')
}